import moment from 'moment';
import React from 'react';
// Agenda Page and Slot Allotment notification
const SixthStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    venue_name,
    address,
    map_link,
    zoom_link,
    registration_date_time,
    conference_location,
    hall_ticket_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Dear ${client_name},` : ` Dear [Client Name],`}</p>

      <p>
        We are excited to share the final agenda for{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : '[Conference Short Name]'}
        </strong>
        . Please find the detailed agenda attached, which includes the sessions,
        workshops, and networking events that will take place.
      </p>

      <p>
        <strong>Event Details:</strong>
        <ul>
          <li>
            <strong>Venue</strong>:{' '}
            {venue_name ? venue_name : '[Session Venue]'}
            <br />
            {address ? address : `[Address]`}
            <br />
            {map_link ? <a href={map_link}>Click Here</a> : `[Google Maps Link]`}
          </li>
          <li>
            <strong>Zoom Link for Virtual Participation</strong>:{' '}
            {zoom_link
              ? <a href={zoom_link}>Click Here</a>
              : `[Access Zoom
            Link]`}
          </li>
        </ul>
      </p>

      <p>
        <strong>Important On-Site Registration Information:</strong>
        <ul>
          <li>
            <strong>Date & Time</strong>:{' '}
            {registration_date_time
              ? moment(registration_date_time).format('YYYY-MM-DD [and] HH:mm')
              : '[Date and Time]'}
          </li>
          <li>
            <strong>Location</strong>:{' '}
            {conference_location ? conference_location : `[Location]`}
          </li>
          <li>
            <strong>What to Bring</strong>: ID, your registration confirmation,
            and presentation materials.
          </li>
        </ul>
      </p>

      <p>
        You can access your <strong>hall ticket/Zoom link</strong> here:{' '}
        {hall_ticket_link ? <a href={hall_ticket_link}>Click Here</a> : `[Access Link]`}.
        {/* <a href={contact_support}>Click Here</a> */}
      </p>

      <p>
        Should you need any assistance or have questions, feel free to contact
        us. We look forward to your participation and a successful event!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default SixthStepTemplate;
